export const dressArr = [
    {
        "id": 1,
        "name": "CERTIFICATE IN FUNDAMENTAL OF FASHION DESIGN (CFFD)",
        "course_info": "This comprehensive course provides the groundwork for aspiring designers to understand the core elements of fashion. Students will learn the basics of design theory, garment construction, and fabric science, enabling them to transform creative ideas into wearable art through professional technical skills.",
        "eligibility_critaria": "Age: 12+",
        "course_duration": "7 Months",
        "syllabus_highlight": "Baby summer items, Petticoat, Umbrella Kurti & Palazzo, A-line Kurti & Straight Cut Pant, Princess Cut blouse etc.",
        "fees_structure": {
            "one_time_amount": "4,602",
            "emi_total_amount": "5,668"
        }
    },
    {
        "id": 2,
        "name": "CERTIFICATE MASTER CLASS IN BLOUSE DESIGN (CMBD)",
        "course_info": "Master the intricate art of blouse making with this specialized course. It focuses on precision cutting, various necklines, and back designs to suit different body types and occasions. Perfect for individuals looking to start a boutique or offer customized tailoring services.",
        "eligibility_critaria": "Age: 12+",
        "course_duration": "4 Months",
        "syllabus_highlight": "Introduction, Plain cut, Hakoba cut, Choli cut, Designer pattern study etc. ",
        "fees_structure": {
            "one_time_amount": "2,950",
            "emi_total_amount": "3,776"
        }
    },
     {
        "id": 3,
        "name": "CERTIFICATE IN ADVANCED WOMEN FASHION DESIGN (CAWFD)",
        "course_info": "This advanced program explores complex silhouettes and high-end garment construction for women’s wear. Students dive deep into couture techniques, draping, and intricate detailing. It is designed for those who wish to elevate their tailoring skills to a professional designer level.",
        "eligibility_critaria": "Age: 12+",
        "course_duration": "4 Months",
        "syllabus_highlight": "Introduction, Plain cut, Hakoba cut, Choli cut, Designer pattern study etc. ",
        "fees_structure": {
            "one_time_amount": " 3,894",
            "emi_total_amount": "4,720"
        }
    },
    {
        "id": 4,
        "name": "CERTIFICATE IN HANDMADE FASHION JEWELLERY (CHFJ)",
        "course_info": "Discover the craft of creating unique, handcrafted accessories that complement modern fashion. This course teaches the use of various materials like clay, beads, and silk threads to design custom jewelry. Ideal for creative entrepreneurs looking to launch their own accessory brand.",
        "eligibility_critaria": "Age: 12+",
        "course_duration": "3 Months",
        "syllabus_highlight": "Introduction, Plain cut, Hakoba cut, Choli cut, Designer pattern study etc. ",
        "fees_structure": {
            "one_time_amount": "2,832",
            "emi_total_amount": "3,600"
        }
    },
    {
        "id": 5,
        "name": "CERTIFICATE IN HANDMADE TEXTILE DESIGN (CHTD)",
        "course_info": "Explore the traditional and modern techniques of surface ornamentation and fabric manipulation. This course focuses on hand-painting, block printing, and embroidery to create custom textile patterns. Learn to add value to plain fabrics for the fashion and home decor industry.",
        "eligibility_critaria": "Age: 12+",
        "course_duration": "3 Months",
        "syllabus_highlight": "Introduction, Plain cut, Hakoba cut, Choli cut, Designer pattern study etc. ",
        "fees_structure": {
            "one_time_amount": "3,304",
            "emi_total_amount": "4,130"
        }
    },
]
